import type { TeaserBaseProps, TeaserTextProps } from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'
import { Body, Content, Title } from '@bonniernews/dn-design-system-web/helpers/teaser.tsx'

import { TeaserCard } from '@bonniernews/dn-design-system-web/components/teaser-card/teaser-card.tsx'

interface TeaserTipsaProps extends TeaserBaseProps, TeaserTextProps {}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-tipsa](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-tipsa)
 * - Storybook: [TeaserTipsa](https://designsystem.dn.se/?path=/docs/section-teasertipsa--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/teaser-tipsa/teaser-tipsa.scss'`
 */
export const TeaserTipsa = ({ targetLink, areaType, title, text, classNames, attributes = {} }: TeaserTipsaProps) => {
  const classes = formatClassString(['ds-teaser', 'ds-teaser--tipsa', classNames])

  return (
    <TeaserCard areaType={areaType} targetLink={targetLink} classNames={classes} attributes={attributes}>
      <Content>
        <Title title={title} />
        <Body text={text} />
      </Content>
    </TeaserCard>
  )
}
